import { PricingModelItem, PurchaseStudentType } from "services/pricingModel/model";
import { trackEvent } from "services/productAnalytics";

export type SubscriptionAnalyticsEvent =
  | { name: "compare_plans_dialog_opened" }
  | {
      name: "purchase_form_shown";
      type: PurchaseStudentType | "all";
      pricingModelCode: string;
    }
  | {
      name: "pricing_model_selected";
      planName: string;
      code: string;
      type: PurchaseStudentType;
    }
  | ({
      name: "subscription_period_selected";
    } & SubscriptionPlanContext)
  | ({
      name: "subscription_plan_purchased";
    } & SubscriptionPlanContext)
  | ({
      name: "subscription_plan_purchase_error";
    } & SubscriptionPlanContext)
  | ({
      name: "lesson_package_selected";
    } & LessonPackageContext)
  | ({ name: "lesson_package_purchase_error" } & LessonPackageContext)
  | ({
      name: "lesson_package_purchased";
    } & LessonPackageContext)
  | { name: "subscription_payment_retry_clicked"; paymentStatus?: string }
  | { name: "subscription_payment_retry_succeeded" }
  | { name: "subscription_payment_retry_failed" };

type SubscriptionPlanContext = {
  period: string;
  price: number;
  currency: string;
  lengthDays: number;
};

type LessonPackageContext = {
  package_name: string;
  price: number;
  currency: string;
  lessonAmount: number;
};

export function trackPricingItemSelection(pricingItem: PricingModelItem) {
  if (pricingItem.purchase_type === "subscription") {
    trackEvent(
      "subscription_period_selected",
      getSubscriptionPlanTrackingContext(pricingItem)
    );
  } else {
    trackEvent("lesson_package_selected", getLessonPackageTrackingContext(pricingItem));
  }
}

export function trackPricingItemPurchase(pricingItem: PricingModelItem) {
  if (pricingItem.purchase_type === "subscription") {
    trackEvent(
      "subscription_plan_purchased",
      getSubscriptionPlanTrackingContext(pricingItem)
    );
  } else {
    trackEvent("lesson_package_purchased", getLessonPackageTrackingContext(pricingItem));
  }
}

export function trackPricingItemPurchaseError(pricingItem: PricingModelItem) {
  if (pricingItem.purchase_type === "subscription") {
    trackEvent(
      "subscription_plan_purchase_error",
      getSubscriptionPlanTrackingContext(pricingItem)
    );
  } else {
    trackEvent(
      "lesson_package_purchase_error",
      getLessonPackageTrackingContext(pricingItem)
    );
  }
}

export const getSubscriptionPlanTrackingContext = (
  pricingItem: PricingModelItem
): SubscriptionPlanContext => ({
  period: pricingItem.name,
  price: pricingItem.price,
  currency: pricingItem.currency,
  lengthDays: pricingItem.length as number,
});

export const getLessonPackageTrackingContext = (
  pricingItem: PricingModelItem
): LessonPackageContext => ({
  package_name: pricingItem.name,
  price: pricingItem.price,
  currency: pricingItem.currency,
  lessonAmount: pricingItem.number as number,
});
